import React, { useState, forwardRef } from 'react';
import { motion } from 'framer-motion';

export const Input = forwardRef(({ className = '', label, error, icon, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div className="w-full">
            {label && (
                <label className="block text-sm font-medium text-slate-300 mb-1.5 ml-1">
                    {label}
                </label>
            )}
            <div className="relative">
                {icon && (
                    <div className={`absolute left-3 top-1/2 -translate-y-1/2 transition-colors duration-200 ${isFocused ? 'text-cyan-400' : 'text-slate-500'}`}>
                        {icon}
                    </div>
                )}
                <input
                    ref={ref}
                    onFocus={(e) => { setIsFocused(true); props.onFocus?.(e); }}
                    onBlur={(e) => { setIsFocused(false); props.onBlur?.(e); }}
                    className={`
            w-full rounded-xl border-2 bg-slate-800/50 px-4 py-3 text-white placeholder-slate-500 transition-all duration-300
            focus:border-cyan-500 focus:bg-slate-800 focus:outline-none focus:ring-0
            focus:shadow-[0_0_20px_rgba(6,182,212,0.2)]
            disabled:cursor-not-allowed disabled:bg-slate-900 disabled:text-slate-600
            ${icon ? '!pl-12' : ''}
            ${error ? 'border-red-500 focus:border-red-500 shadow-[0_0_10px_rgba(239,68,68,0.2)]' : 'border-slate-700'}
            ${className}
          `}
                    {...props}
                />
            </div>
            {error && (
                <motion.p
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="mt-1.5 text-sm text-red-400 ml-1 font-medium"
                >
                    {error}
                </motion.p>
            )}
        </div>
    );
});

Input.displayName = 'Input';
